import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from "@angular/core";
import { RouterLink } from "@angular/router";
import { ButtonDirective } from "primeng/button";

import { FeatureBadgeComponent } from "../../ui/feature-badge/feature-badge.component";

// "Request rate/charges from agent" and "X requests sent" in a Freight lane or Charges location header.
@Component({
  selector: "app-agent-request-links",
  templateUrl: "./agent-request-links.component.html",
  styleUrls: ["./agent-request-links.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, RouterLink, FeatureBadgeComponent],
})
export class AgentRequestLinksComponent {
  readonly label = input.required<string>();
  readonly count = input(0);
  readonly queryParams = input<Record<string, string | number>>({});
  readonly requested = output<void>();

  public readonly countLabel = computed(
    () => `${this.count()} ${this.count() === 1 ? "request" : "requests"} sent`,
  );
}
